import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const signInUser = React.createContext({});
export let signInUserMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMSignInUser = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  signInUserMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(signInUserMachine);
  useEffect(() => {
    send({ type: 'START' });
  }, []);
  return {
    signInUserMachine,
    signInUserState: state,
    signInUserSend: send,
  };
};
